// extracted by mini-css-extract-plugin
export default {"textTitle":"refer-friend-screen_textTitle__NAQPK","inputArea":"refer-friend-screen_inputArea__AqwJw","infoMessage":"refer-friend-screen_infoMessage__HSLLd"};